import { FormattedDate, FormattedMessage } from 'react-intl';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { parseTransactionNumber } from '../AccountHistory';
import * as selectors from '../AccountHistorySelectors';
import { connect } from 'react-redux';
import styles from './AccountHistoryTable.module.css';
import messages from './AccountHistoryTable.messages';
import { Table } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (
    state: RootState,
    ownProps: TAccountHistoryTableProps
) => ({
    statements: selectors.getAccountHistory(state, ownProps.accountId),
    hasTransactions: selectors.hasMadeTransactions(state, ownProps.accountId)
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

type TAccountHistoryTableProps = { productType: string; accountId: string };

const AccountHistoryTable = ({
    productType,
    statements,
    hasTransactions
}: PropsFromRedux & TAccountHistoryTableProps) => {
    if (!hasTransactions) {
        return (
            <div className={styles.AccountHistoryTable}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <FormattedMessage {...messages.noTransactions} />
                    </div>
                </div>
            </div>
        );
    }

    const columns = [
        {
            id: 'date',
            header: () => <FormattedMessage {...messages.date} />,
            accessorKey: 'date',
            cell: (info: any) => (
                <FormattedDate
                    day="numeric"
                    month="short"
                    year="numeric"
                    value={new Date(info.getValue())}
                />
            ),
            size: 120
        },
        {
            id: 'description',
            header: '',
            accessorKey: 'description'
        },
        {
            id: 'principal',
            header: () => <FormattedMessage {...messages.principal} />,
            accessorKey: 'transaction_principal',
            cell: (info: any) => (
                <FormattedCurrency
                    value={parseTransactionNumber(info.getValue())}
                />
            ),
            size: 120,
            visible: productType !== 'merchant_cash_advance'
        },
        {
            id: 'interest',
            header: () => <FormattedMessage {...messages.interest} />,
            cell: (info: any) => (
                <FormattedCurrency
                    value={
                        parseTransactionNumber(
                            info.row.original.transaction_interest
                        ) +
                        parseTransactionNumber(
                            info.row.original.transaction_fees
                        )
                    }
                />
            ),
            size: 120,
            visible: productType !== 'merchant_cash_advance'
        },
        {
            id: 'balance',
            header: () => <FormattedMessage {...messages.balance} />,
            accessorKey: 'closing_balance',
            cell: (info: any) => <FormattedCurrency value={info.getValue()} />,
            size: 120
        }
    ];
    return (
        <div data-testid="account-history-table">
            <Table columns={columns} data={statements} maxHeight={500} />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(AccountHistoryTable);
